import React, { Children } from "react";
import { FormField } from "admin-on-rest";
import IconHelp from "material-ui/svg-icons/action/help-outline";
import IconInfo from "material-ui/svg-icons/action/info-outline";
import { iconStyles } from "../styles";
import { red500 } from "material-ui/styles/colors";
import { checkSources } from "../defaultValues";
import { DivContainer } from "../styled";
export const renderItemForm = (children, record, resource, basePath) =>
  Children.map(
    children,
    (input) =>
      input &&
      !checkSources(input.props, "properties.") &&
      !checkSources(input.props, "photos") &&
      !checkSources(input.props, "description") &&
      !checkSources(input.props, "payment.") &&
      !checkSources(input.props, "shipping.") &&
      !checkSources(input.props, "event.") &&
      !checkSources(input.props, "locale.") &&
      renderItemField(input, record, resource, basePath)
  );

export const renderPhotosForm = (children, record, resource, basePath) =>
  Children.map(
    children,
    (input) =>
      input &&
      (checkSources(input.props, "photos") ||
        checkSources(input.props, "description")) &&
      renderItemField(input, record, resource, basePath)
  );

export const renderMainItemForm = (children, record, resource, basePath) =>
  Children.map(
    children,
    (input) =>
      input &&
      (checkSources(input.props, "active") ||
        checkSources(input.props, "account_id") ||
        checkSources(input.props, "name") ||
        checkSources(input.props, "slug") ||
        checkSources(input.props, "category_id") ||
        checkSources(input.props, "photos") ||
        checkSources(input.props, "description")) &&
      renderItemField(input, record, resource, basePath)
  );

export const renderPriceItemForm = (children, record, resource, basePath) =>
  Children.map(
    children,
    (input) =>
      input &&
      (checkSources(input.props, "price") ||
        checkSources(input.props, "discount") ||
        checkSources(input.props, "partner_margin") ||
        checkSources(input.props, "margin")) &&
      renderItemField(input, record, resource, basePath)
  );

export const renderSideItemForm = (children, record, resource, basePath) =>
  Children.map(
    children,
    (input) =>
      input &&
      (checkSources(input.props, "product_type") ||
        checkSources(input.props, "tags") ||
        checkSources(input.props, "brand") ||
        checkSources(input.props, "sort_order")) &&
      renderItemField(input, record, resource, basePath)
  );

export const renderSideItemFormCollection = (
  children,
  record,
  resource,
  basePath
) =>
  Children.map(
    children,
    (input) =>
      input &&
      checkSources(input.props, "collections") &&
      renderItemField(input, record, resource, basePath)
  );

export const renderItemField = (input, record, resource, basePath) => (
  <div
    key={input.props.source}
    className={`aor-input-${input.props.source}`}
    style={input.props.style}
  >
    <FormField
      input={input}
      resource={resource}
      record={record}
      basePath={basePath}
    />
    {input.props.source === "discount" && (
      <span data-tip="" data-for="discounttooltip">
        <IconHelp style={iconStyles} color={red500} />
      </span>
    )}
    {input.props.source === "sort_order" && (
      <span data-tip="" data-for="sort_ordertooltip">
        <IconInfo style={iconStyles} color={red500} />
      </span>
    )}
    {input.props.source === "slug" && (
      <span data-tip="" data-for="slugtooltip">
        <IconInfo style={iconStyles} color={red500} />
      </span>
    )}
  </div>
);

export const renderItemFormShipping = (children, record, resource, basePath) =>
  Children.map(
    children,
    (input) =>
      input &&
      (input.props.source === "shipping.weight" ||
        input.props.source === "shipping.free_shipping" ||
        input.props.source === "shipping.subsidy") && (
        <div
          key={input.props.source}
          className={`aor-input-${input.props.source}`}
          style={input.props.style}
        >
          <FormField
            input={input}
            resource={resource}
            record={record}
            basePath={basePath}
          />
        </div>
      )
  );
export const renderItemFormPayment = (children, record, resource, basePath) =>
  Children.map(
    children,
    (input) =>
      input &&
      (input.props.source === "payment.installment" ||
        input.props.source === "payment.credit_card.bin" ||
        input.props.source === "payment.enabled_payments") && (
        <div
          key={input.props.source}
          className={`aor-input-${input.props.source}`}
          style={input.props.style}
        >
          {input.props.source === "payment.credit_card.bin" && (
            <DivContainer>Creadit Card Payment Settings</DivContainer>
          )}
          <FormField
            input={input}
            resource={resource}
            record={record}
            basePath={basePath}
          />
        </div>
      )
  );
//paymentmode
//renderItemFormPaymentMode
export const renderItemFormPaymentMode = (
  children,
  record,
  resource,
  basePath
) =>
  Children.map(
    children,
    (input) =>
      input &&
      input.props.source === "payment_mode_id" && (
        <div
          key={input.props.source}
          className={`aor-input-${input.props.source}`}
          style={input.props.style}
        >
          <FormField
            input={input}
            resource={resource}
            record={record}
            basePath={basePath}
          />
        </div>
      )
  );

/**
   * 
   * const renderPriceItemForm = (children, record, resource, basePath) =>
  Children.map(
    children,
    input =>
      input &&
      ((checkSources(input.props, "price") ||
        checkSources(input.props, "discount") ||
        checkSources(input.props, "margin")) &&
        renderItemField(input, record, resource, basePath))
  );
   */



// WEBPACK FOOTER //
// ./src/products/createfield/FormProductField.js